import { CAPABILITIES } from "@/data/site";

const Item = ({ text, outline }) => (
  <span className="flex items-center gap-10 pr-10 md:gap-14 md:pr-14">
    <span className={`whitespace-nowrap text-5xl font-extrabold tracking-[-0.04em] md:text-7xl ${outline ? "text-transparent [-webkit-text-stroke:1px_rgba(203,213,225,0.55)]" : "text-white"}`}>{text}</span>
    <span className="grid grid-cols-2 gap-1" aria-hidden="true">
      <span className="h-2 w-2 rounded-[2px] bg-cyan-400" /><span className="h-2 w-2 rounded-[2px] bg-blue-500" />
      <span className="h-2 w-2 rounded-[2px] bg-transparent" /><span className="h-2 w-2 rounded-[2px] bg-violet-500" />
    </span>
  </span>
);

export const Marquee = () => {
  const row = [...CAPABILITIES, ...CAPABILITIES];
  return (
    <section aria-labelledby="expertise-label" className="relative overflow-hidden border-y border-white/10 bg-[#050b14] py-10 md:py-14" data-testid="capabilities-strip">
      <div className="container-q mb-8 flex flex-wrap items-center justify-between gap-3">
        <h2 id="expertise-label" className="eyebrow text-slate-400">Areas of expertise</h2>
        <ul className="sr-only">{CAPABILITIES.map((c) => <li key={c}>{c}</li>)}</ul>
        <p className="font-mono text-[12px] text-slate-400">{CAPABILITIES.join("  |  ")}</p>
      </div>
      <div className="marquee-wrap relative" aria-hidden="true">
        <div className="marquee-track flex w-max">
          {[0, 1].map((k) => (
            <div key={k} className="flex">
              {row.map((c, i) => <Item key={`${k}-${i}`} text={c} outline={i % 2 === 1} />)}
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#050b14] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#050b14] to-transparent" />
      </div>
    </section>
  );
};
